<template>
  <form v-if="!isLoading" @submit.prevent="onSubmit" class="user-form">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 col-md-12">
          <div class="row">
            <div class="col-12">
              <app-input
                label="CPF"
                :model="(client.cpf || '') | VMask('###.###.###-##')"
                disabled
              ></app-input>
            </div>
            <div class="col-12">
              <app-input
                label="Nome Completo"
                v-model="client.name"
                :errors="errors.name"
                required
              ></app-input>
            </div>           
            <div class="col-12">
              <app-input
                label="Telefone"
                v-model="client.phone"
                v-mask="'(##) ####-####'"
                :errors="errors.phone"
              ></app-input>
            </div>
            <div class="col-12">
              <app-input
                label="Email" 
                v-model="client.email"
                :errors="errors.email"
                required 
              ></app-input>
            </div>
            <div class="col-6">
              <b-field label="Data de Nascimento" required>
                <b-datepicker
                  v-model="client.birthdate"
                  :date-formatter="bDateFormatter"
                  placeholder="Selecionar data..."
                  trap-focus
                ></b-datepicker>
              </b-field>
            </div>
            <div class="col-6">
              <div class="app-radio" required>
                <label>Sexo</label>
                <div class="app-radio__options">
                  <b-radio v-model="client.sex" name="name" native-value="M"
                    >Masculino</b-radio
                  >
                  <b-radio v-model="client.sex" name="name" native-value="F"
                    >Feminino</b-radio
                  >
                </div>
              </div>
            </div>
            <div class="col-6">
              <b-field label="Senha" :required="firstAccess">
                <b-input
                  v-model="client.password"
                  placeholder="Senha"
                  type="password"
                  password-reveal
                ></b-input>
              </b-field>
              <div v-if="!$v.client.password.minLength" class="error">
                A senha deve conter no mínimo 6 caracteres
              </div>
            </div>
            <div class="col-6">
              <b-field label="Confirmar Senha" :required="firstAccess">
                <b-input
                  v-model="client.password_confirmation"
                  placeholder="Confirmar Senha"
                  type="password"
                  password-reveal
                ></b-input>
              </b-field>
              <div
                v-if="!$v.client.password_confirmation.sameAsPassword"
                class="error"
              >
                As senhas devem ser iguais
              </div>
            </div>

            <div class="col-6 mt-5">
              <app-input
                @change="validCellPhone"

                label="Celular"
                v-model="client.cellphone"
                v-mask="'(##) #####-####'"
                :errors="errors.cellphone"
                required
              ></app-input>
              <div v-if="!$v.client.cellphone.minLength" class="error">
                Insira um celular valido.
              </div>
            </div>
            <div class="col-md-3 mt-5"> 
              <label>VERIFICAÇÃO</label>
              <button
                class="app-button-options"
                @click="generateToken"
                type="button" 
              >
                ENVIAR
              </button>
            </div>
            <div class="col-9">
              <app-input
                id="token" 
                v-model="client.token"
                label="CÓD. VERIFICAÇÃO"
                required 
              ></app-input>
            </div>
            <div class="col-md-3 mt-4">
              <button
                class="app-button-options" 
                @click="validToken"
                type="button"
              >
                CONFIRMAR
              </button>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-12">
          <div class="row">
            <div class="col-12">
              <app-input
                label="CNPJ (Unidade participante)"
                v-model="client.cnpj"
                v-mask="'##.###.###/####-##'"
                @change="validCnpj"
                :errors="errors.cnpj"
                required
              ></app-input>
              <div v-if="!$v.client.cnpj.minLength" class="error">
                Insira um CNPJ valido.
              </div>
            </div>
            <div class="col-sm-12">
              <app-input
                label="CEP"
                v-model="client.address.postal_code" 
                :errors="errors['address.postal_code']" 
                @change="getCepInfo"
                maxlength="9"
                v-mask="'#####-###'"
              ></app-input>
            </div>
            <div class="col-12">
              <app-input
                label="Endereço"
                v-model="client.address.street"
                :errors="errors['address.street']"
                required
              ></app-input>
            </div>
            <div class="col-4">
              <app-input
                label="Número"
                v-model="client.address.number"
                :errors="errors['address.number']"
                required
              ></app-input>
            </div>
            <div class="col-4">
              <app-input
                label="Complemento"
                v-model="client.address.complement"
                :errors="errors['address.complement']"
              ></app-input>
            </div>
            <div class="col-4">
              <app-input
                label="Bairro"
                v-model="client.address.neighborhood"
                :errors="errors['address.neighborhood']"
                required
              ></app-input>
            </div>
            <div class="col-6">
              <app-autocomplete
                label="Cidade"
                field="name_with_state"
                :searchFunction="searchCityFn"
                :resourceIdFunction="resourceCityFn"
                v-model="client.address.city_id"
                :errors="errors['address.city_id']"
                required
              ></app-autocomplete>
            </div>
            <div class="col-8">
              <app-file-picker
                label="Foto"
                accept="image/*"
                v-model="imageToCrop"
                @fileDeleted="onFileDeleted"
              ></app-file-picker>

              <app-image-cropper
                v-if="imageToCrop"
                :src="imageToCrop"
                :aspectRatio="1"
                class="cropper-image"
                @croppedImage="onCropperImage"
              ></app-image-cropper>
            </div>

            <div v-if="client.picture" class="col-4">
              <img
                :src="client.picture"
                alt="Imagem do Usuário"
                class="picture-preview"
              />
            </div>
          </div>
        </div>
      </div>
      <div v-if="firstAccess" class="row mt-4">
        <div class="col-12 regulation-text-container">
          <p>REGULAMENTO CLUBE DE BENEFÍCIOS PHILCO – VENDA E GANHE</p>
          <div v-if="regulation" class="text">
            <div v-html="regulation.text"></div>
          </div>
          <b-checkbox type="checkbox" v-model="acceptRegulation"
            >LI E ESTOU DE ACORDO COM OS TERMOS DO REGULAMENTO
            APRESENTADO.</b-checkbox
          >
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-12 text-center">
          <button
            :disabled="$v.$invalid || isSaving"
            type="submit"
            v-app-button
          >
            Salvar
          </button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import RegulationService from '@/services/regulation.service';
import ValidateCellPhoneService from '@/services/validate-cellphone.service';
import AddressService from '@/services/address.service';
import ClientService from '@/services/client.service';
import CityService from '@/services/city.service';
import BuefyMixin from '@/mixins/BuefyMixin';
import ToastMixin from '@/mixins/ToastifyMixin';

import { required, minLength, sameAs } from 'vuelidate/lib/validators';
import * as moment from 'moment';

export default {
  name: 'user-form',
  mixins: [BuefyMixin, ToastMixin],
  props: ['errors', 'isSaving', 'cpf', 'firstAccess'],
  data: () => {
    return {
      isLoading: true,
      regulation: null,
      imageToCrop: null,
      acceptRegulation: false,
      client: {
        name: null,
        email: null,
        password: null,
        password_confirmation: null,
        cpf: null,
        cnpj: null,
        unit_cnpj: null,
        birthdate: null,
        sex: null,
        cellphone: null,
        phone: null,
        token: null,
        address: {
          postal_code: null,
          street: null,
          number: null,
          neighborhood: null,
          city_id: null,
        },
      },
    };
  },
  validations() {
    return {
      acceptRegulation: {
        checked(value) {
          return value == !!this.firstAccess;
        },
      },
      client: {
        name: { required },
        email: { required },
        password: {
          required(value) {
            return !this.firstAccess || !!value;
          },
          minLength: minLength(6),
        },
        password_confirmation: { sameAsPassword: sameAs('password') },
        cellphone: { 
          required ,
          minLength: minLength(5)
          },
        cnpj: { 
          required,
          minLength: minLength(14)
        },
        birthdate: { required },
        token: { required },
        sex: { required },
        address: {
          street: { required },
          number: { required },
          neighborhood: { required },
          city_id: { required },
        },
      },
    };
  },
  methods: {
    load() {
      this.isLoading = true;

      ClientService.getSelf()
        .then(({ data: client }) => {
          this.client = {
            ...client,
            birthdate: client.birthdate ? new Date(client.birthdate) : null,
            address: client.address || {},
          };
        })
        .finally(() => (this.isLoading = false));
    },
    loadIncomplete(cpf) {
      this.isLoading = true;

      ClientService.getIncomplete(cpf)
        .then(({ data: client }) => {
          this.client = {
            ...client,
            birthdate: client.birthdate ? new Date(client.birthdate) : null,
            address: client.address || {},
          };
        })
        .finally(() => (this.isLoading = false));
    },
    loadRegulation() {
      RegulationService.get().then(
        ({ data: regulation }) => (this.regulation = regulation)
      );
    },
    onSubmit() {
      this.$emit('submit', {
        ...this.client,
        birthdate: moment(this.client.birthdate).format('DD/MM/YYYY'),
      });

      this.client.password = null;
      this.client.password_confirmation = null;
    },
    onCropperImage(value) {
      this.client.picture = value;
      this.imageToCrop = '';
    },

    // Funcao para check de cnpj, utilizando unit_cnpj do db.
    validCnpj(){
      if(
        this.client.cnpj == null
        || (this.client.cnpj.length > 18)
        || !(this.validarCNPJ(this.client.cnpj))
      )
      {
        this.toastify('Digite um CNPJ valido para prosseguir', 'error');
        return;
      }
    },

    validarCNPJ(cnpj) {
 
    cnpj = cnpj.replace(/[^\d]+/g,'');
 
    if(cnpj == '') return false;
     
    if (cnpj.length != 14)
        return false;
 
    // Elimina CNPJs invalidos conhecidos mas que passam no algoritmo
    if (cnpj == "00000000000000" || 
        cnpj == "11111111111111" || 
        cnpj == "22222222222222" || 
        cnpj == "33333333333333" || 
        cnpj == "44444444444444" || 
        cnpj == "55555555555555" || 
        cnpj == "66666666666666" || 
        cnpj == "77777777777777" || 
        cnpj == "88888888888888" || 
        cnpj == "99999999999999")
        return false;
         
    // Valida DVs
    var tamanho = cnpj.length - 2
    var numeros = cnpj.substring(0,tamanho);
    var digitos = cnpj.substring(tamanho);
    var soma = 0;
    var pos = tamanho - 7;
    for (var i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2)
            pos = 9;
    }
    var resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(0))
        return false;
         
    tamanho = tamanho + 1;
    numeros = cnpj.substring(0,tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2)
            pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(1))
          return false;
           
    return true;
    },
    onFileDeleted() {
      this.client.picture = '';
    },
    getCepInfo() {
      this.cepLoading = true;
      if (this.client.address.postal_code < 8) return;

      AddressService.cepInfo(this.client.address.postal_code)
        .then(({ data }) => {
          if (data === 422) {
            this.toastify('CEP Inválido', 'error');
            return;
          }
          this.client.address.street = data.logradouro;
          this.client.address.neighborhood = data.bairro;
          this.client.address.city_id = data.city_id;
        })
        .finally(() => (this.cepLoading = false));
    },
    searchCityFn: CityService.search,
    resourceCityFn: CityService.getId,
    generateToken() {  
      if(
        this.client.cellphone == null
        || this.client.cellphone == ''
        )
      {
        this.toastify('Insira um celular valido para prosseguir', 'error');
        return; 
      } 
      
      ValidateCellPhoneService.generate(this.client.cellphone, this.client.cpf)
        .then(({data}) => {
          this.toastify(data.message, 'success');
          this.confirm_token = true; 
        });
    },
    validToken() { 
      if(
        this.client.token == null
        || this.client.token == ''
        )
      {
        this.toastify('Insira um token valido para prosseguir', 'error');
        return;
      }
      
      ValidateCellPhoneService.validate(this.client.token, this.client.cpf)
        .then(
          ({data}) => {  
            this.toastify(data.message, data.success);
            this.confirm_token = true;
          },
          () => {
            this.confirm_token = false;
            this.toastify('Token informado não confere', 'error');
            return;
          }
        );
    },
    validCellPhone() { 
      console.log(this.client.cellphone.length);
  
      if(
        this.client.cellphone == null
        )
      {
        this.toastify('Digite um numero valido para prosseguir', 'error');
        this.client.cellphone = null;
        return;
      }
      ValidateCellPhoneService.check(this.client.cellphone, this.client.cpf)
        .then(({data}) => {  
          this.toastify(data.message, data.success);
          this.client.cellphone = data.success == "success" ? this.client.cellphone : null;
        });
    }
  }, 
  mounted() {
    !this.cpf && this.load();
    this.cpf && this.loadIncomplete(this.cpf);
    this.confirm_token = true;

    if (this.firstAccess) this.loadRegulation();
  },
};
</script>

<style lang="scss" scoped>
.user-form {
  .text-center {
    text-align: center;
  }

  .picture-preview {
    height: 100px;
    width: 100px;
    object-fit: cover;
    border-radius: 50%;
  }
  .message {
    font-style: italic;
    color: var(--color-danger);
    background: none;
  }

  .cropper-image {
    max-height: 400px;
  }
}

div.regulation-text-container {
  p {
    text-align: center;
    font-weight: bold;
  }

  .text {
    max-height: 250px;
    overflow-y: scroll;
    margin: 16px 0;

    > div {
      font-size: 0.9em;
      color: var(--text-color-light);

      >>> p {
        margin-bottom: 10px;
      }
    }
  }
}

label.b-checkbox {
  margin-top: 32px;
}

.error {
  font-size: 0.8em;
  color: #ff6363;
}
</style>
